/*
Copyright (c) 2025, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import { SkeletonProps } from './types';
import './styles.scss';
import { generateID } from '../../base/helper';

const Skeleton: React.FC<SkeletonProps> = ({
  id = generateID('clientos-ui-toolkit-skeleton'),
  width = 180,
  height = 180,
  radius = 10
}) => {
  return (
    <div
      id={id}
      className="clientos-ui-toolkit-skeleton"
      style={{
        width: width,
        height: height,
        borderRadius: radius
      }}
    ></div>
  );
};

export default Skeleton;
